export default {
    // Header
    brand: 'PlayCatGames',
    nav: {
        home: 'Accueil',
        games: 'Jeux',
        categories: 'Catégories',
        about: 'À propos'
    },
    search: {
        placeholder: 'Rechercher des jeux de chats...'
    },

    // Hero Section
    hero: {
        title: 'Jeux de Chats',
        description: 'Les jeux de chats sur PlayCatGames vous permettent de jouer, prendre soin et interagir avec des chats virtuels de toutes sortes de façons amusantes et intelligentes. Vous pouvez cliquer ou toucher pour lancer des jouets à travers l\'écran, faire glisser et déposer des tenues sur un personnage, ou utiliser des réflexes rapides pour attraper des poissons et chasser des récompenses.',
        subtitle: 'Certains jeux de chats testent le timing pendant que vous sautez, courez ou grimpez, tandis que d\'autres se concentrent sur des actions simples comme nourrir, toiletter ou taper pour marquer des points. Chaque titre est conçu pour un plaisir instantané dans votre navigateur. Pas d\'installations. Pas de téléchargements. Juste miaou !',
        buttons: {
            start: 'Commencer à Jouer',
            browse: 'Parcourir les Catégories'
        },
        stats: {
            games: 'Jeux Gratuits',
            categories: 'Catégories de Jeux',
            free: 'Expérience Gratuite',
            available: 'Toujours Disponible'
        }
    },

    // Games Section
    games: {
        title: 'Jeux de Chats Populaires',
        subtitle: 'Découvrez les jeux de chats en ligne gratuits les plus populaires pour les joueurs de tous âges',
        filters: {
            all: 'Tous',
            dressUp: 'Habillage',
            care: 'Soins',
            puzzle: 'Puzzle',
            arcade: 'Arcade',
            simulation: 'Simulation'
        },
        loadMore: 'Charger Plus de Jeux',
        gameCategories: {
            arcade: 'Arcade',
            simulation: 'Simulation',
            care: 'Soins',
            puzzle: 'Puzzle',
            dressUp: 'Habillage'
        }
    },

    // Categories Section
    categories: {
        title: 'Catégories de Jeux',
        subtitle: 'Chaque jeu de chat est construit autour d\'activités que les joueurs apprécient le plus : stylisme, soins aux animaux, ou courir à travers des parcours amusants',
        browse: 'Parcourir la Catégorie',
        featuredGames: 'Jeux en Vedette',
        gameCount: 'Jeux',
        types: {
            dressUp: {
                name: 'Jeux d\'Habillage de Chats',
                description: 'Les jeux d\'habillage de chats laissent libre cours à votre créativité. Mélangez les tenues, ajoutez des accessoires et débloquez des looks thématiques des ensembles fantastiques aux équipements saisonniers.'
            },
            simulation: {
                name: 'Simulation et Jeu de Rôle de Chats',
                description: 'Dans les jeux de simulation, vous entrez dans les pattes d\'un chat. Errez, explorez et vivez la vie curieuse d\'un chaton.'
            },
            puzzle: {
                name: 'Gestion de Chats et Jeux de Puzzle',
                description: 'Pour les fans de stratégie, les jeux de puzzle et de gestion de chats offrent des rebondissements intelligents. Équilibrez plusieurs chats, résolvez des défis d\'empilement délicats.'
            },
            arcade: {
                name: 'Jeux d\'Arcade et d\'Action de Chats',
                description: 'Jeux d\'arcade de chats au rythme rapide qui testent vos réflexes et votre agilité. Sautez, courez, attrapez et profitez d\'expériences de jeu palpitantes.'
            }
        },
        additional: {
            title: 'Explorez Plus de Types de Jeux de Chats',
            description: 'Notre collection de jeux de chats couvre chaque humeur et préférence : jeu de mode, soins aux animaux, puzzles délicats ou courses d\'arcade amusantes. Nos jeux de chats basés sur navigateur sont gratuits, sûrs et prêts à jouer en quelques secondes.',
            motto: 'Choisissez simplement un jeu, touchez démarrer et laissez le plaisir prendre vie !'
        }
    },

    // About Section
    about: {
        title: 'À propos de PlayCatGames',
        description: [
            'PlayCatGames est votre destination ultime pour explorer le merveilleux monde des jeux de chats. Nous avons soigneusement sélectionné une collection de jeux thématiques de chats en ligne gratuits adaptés aux joueurs de tous âges.',
            'Des jeux d\'habillage mignons aux aventures d\'arcade excitantes, des simulations de soins chaleureuses aux défis de puzzle intelligents, notre collection de jeux couvre tout ce que les amoureux des chats pourraient désirer. Tous les jeux sont soigneusement sélectionnés pour garantir la meilleure expérience de jeu.',
            'Nous croyons que les jeux doivent être instantanés, amusants et facilement accessibles. C\'est pourquoi tous nos jeux peuvent fonctionner directement dans votre navigateur sans télécharger ou installer de logiciel. Cliquez simplement et commencez à jouer !'
        ],
        features: {
            free: '100% Jeux Gratuits',
            mobile: 'Compatible Mobile',
            instant: 'Jeu Instantané',
            safe: 'Sûr et Sécurisé'
        },
        faq: {
            title: 'Questions Fréquemment Posées',
            questions: {
                free: {
                    q: 'Ces jeux sont-ils vraiment gratuits ?',
                    a: 'Oui ! Tous nos jeux de chats sont entièrement gratuits. Vous n\'avez besoin de rien payer pour profiter de tout le contenu du jeu.'
                },
                download: {
                    q: 'Dois-je télécharger un logiciel ?',
                    a: 'Non ! Tous les jeux peuvent fonctionner directement dans votre navigateur. Cliquez simplement sur un jeu pour commencer à jouer, aucun téléchargement ou installation requis.'
                },
                age: {
                    q: 'Pour quel groupe d\'âge ces jeux sont-ils adaptés ?',
                    a: 'Nos jeux de chats conviennent aux joueurs de tous âges. Des jeux d\'habillage simples aux jeux de puzzle difficiles, tout le monde peut trouver des jeux qui lui conviennent.'
                },
                mobile: {
                    q: 'Les jeux supportent-ils les appareils mobiles ?',
                    a: 'Oui ! Tous nos jeux sont optimisés pour fonctionner parfaitement sur PC, tablettes et téléphones. Vous pouvez profiter du plaisir du jeu à tout moment, n\'importe où.'
                },
                updates: {
                    q: 'Ajouterez-vous de nouveaux jeux ?',
                    a: 'Absolument ! Nous mettons régulièrement à jour notre bibliothèque de jeux et ajoutons de nouveaux jeux de chats intéressants. Revenez souvent pour découvrir le contenu de jeux le plus récent.'
                }
            }
        }
    },

    // Footer
    footer: {
        description: 'Votre destination de collection de jeux de chats en ligne gratuits. Découvrez, jouez et profitez de dizaines de jeux thématiques de chats passionnants.',
        quickLinks: 'Liens Rapides',
        gameCategories: 'Catégories de Jeux',
        support: 'Support',
        links: {
            popularGames: 'Jeux Populaires',
            latestGames: 'Derniers Jeux',
            recommendedGames: 'Jeux Recommandés',
            faq: 'FAQ',
            contact: 'Nous Contacter',
            feedback: 'Commentaires',
            privacy: 'Politique de Confidentialité',
            terms: 'Conditions de Service',
            cookies: 'Politique des Cookies',
            sitemap: 'Plan du Site'
        },
        copyright: 'Tous droits réservés.',
        disclaimer: 'Tout le contenu du jeu est obtenu d\'internet uniquement à des fins de divertissement et d\'éducation. Veuillez nous contacter s\'il y a des problèmes de droits d\'auteur.',
        backToTop: 'Retour en Haut',
        friendlyLinks: 'Liens Partenaires'
    },

    // Game Data
    gameData: {
        descriptions: {
            kittyLovesBirds: 'Aidez le chaton à attraper les oiseaux volants et montrez votre vitesse de réaction',
            catPizza: 'Dirigez une pizzeria de chats et faites de délicieuses pizzas pour les clients',
            funnyKittyCare: 'Prenez soin de chatons adorables, nourrissez-les, baignez-les et jouez',
            catsDrop: 'Jeu d\'empilement de chats qui teste vos compétences d\'équilibre et de stratégie',
            catpad: 'Adorable jeu de plateforme de saut de chat',
            funnyKittyDressup: 'Habillez des chatons adorables avec divers vêtements et accessoires',
            kittyCats: 'Jeu décontracté pour interagir avec plusieurs chats adorables',
            dualCat: 'Jeu de défi contrôlant deux chats simultanément',
            funnyKittyHaircut: 'Jeu de beauté concevant des coiffures à la mode pour les chatons',
            catCoffeeShop: 'Dirigez un café de chats et faites de délicieuses boissons'
        },
        categories: {
            puzzle: 'Puzzle',
            simulation: 'Simulation',
            casual: 'Casual',
            action: 'Action',
            adventure: 'Adventure',
            strategy: 'Strategy',
            sports: 'Sports',
            racing: 'Racing',
            dressup: 'Dress Up',
            care: 'Care'
        },
        tags: {
            cute: 'Cute',
            anime: 'Anime',
            dark: 'Dark',
            funny: 'Funny',
            educational: 'Educational',
            multiplayer: 'Multiplayer',
            relaxing: 'Relaxing',
            challenging: 'Challenging',
            colorful: 'Colorful',
            simple: 'Simple',
            complex: 'Complex',
            family: 'Family Friendly',
            kids: 'Kids',
            adult: 'Adult'
        }
    },

    // Common
    common: {
        loading: 'Chargement...',
        error: 'Quelque chose s\'est mal passé',
        retry: 'Réessayer',
        play: 'Jouer',
        language: 'Langue',
        backToHome: 'Retour à l\'Accueil'
    },

    // Legal Pages (simplified)
    legal: {
        privacy: { title: 'Politique de Confidentialité', lastUpdated: 'Dernière Mise à Jour' },
        terms: { title: 'Conditions de Service', lastUpdated: 'Dernière Mise à Jour' },
        cookies: { title: 'Politique des Cookies', lastUpdated: 'Dernière Mise à Jour' }
    },

    // Sitemap
    sitemap: {
        title: 'Plan du Site',
        description: 'Trouvez toutes les pages et contenus sur le site web PlayCatGames'
    }
}